// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/units-of-measure.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/units-of-measure/units-of-measure.js';

mount([g0]);
